import React from "react";
import Layout from "../styles/Layout.js";
import MainContainer from "../styles/MainContainer.js";
import Navbar from "../components/Navbar/Navbar.js";
import SocialNav from "../components/SocialNav/SocialNav.js";
import HomeHeader from "../Sections/Homepage/HomeHeader/HomeHeader.js";
import SkillsSection from "../Sections/Homepage/SkillsSection/SkillsSection";
import ProjectsSection from "../Sections/Homepage/ProjectsSection/ProjectsSection";
import ArticlesSection from "../Sections/Homepage/ArticlesSection/ArticlesSection.js";
import AboutSection from "../Sections/Homepage/AboutSection/AboutSection.js";
import ContactSection from "../Sections/Homepage/ContactSection/ContactSection.js";
import TeamNexaveSection from "../Sections/Homepage/TeamNexaveSection/TeamNexaveSection.js";

export default function Home() {
   return (
      <Layout>
         <Navbar />
         <SocialNav />
         <MainContainer>
            <HomeHeader />
            <SkillsSection />
            <ProjectsSection />
            <TeamNexaveSection />
            <ArticlesSection />
            <AboutSection />
            <ContactSection />
         </MainContainer>
      </Layout>
   );
}
